// Copyright (c) 2022 by Move Closer

import { LocaleMessageObject } from 'vue-i18n'

import backoffice from './backoffice.json'
import dsl from './dsl.json'
import front from './front.json'
import modules from './modules.json'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const backofficeAppEn: LocaleMessageObject = {
  ...dsl,
  ...modules,
  ...backoffice
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const dslEn: LocaleMessageObject = dsl

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const frontAppEn: LocaleMessageObject = {
  ...dsl,
  ...front,
  modules: modules.modules
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const modulesEn: LocaleMessageObject = {
  ...dsl,
  ...front,
  ...modules
}
